import { useContext, useMemo } from "react";
import _ from "lodash";
import { AppContext } from "../AppProvider";
import { fs_db } from "global/firestoreData/appData/fsAppData";
import { fs_dbu } from "global/firestoreData/appData/fsAppDataUpdate";

export const useDatabaseFns = ({ fsdb, useProdDb }) => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainDb, app_alts, app_prods } = app_state ?? {}
  const { altDb } = app_alts ?? {}

  return useMemo(() => {

    if (!fsdb || !mainDb) return undefined;

    let _currentDb = mainDb

    if (useProdDb) {
      _currentDb = app_prods.prodDb
    }

    // Collections that should route to altDb
    const altCollections = ["altProfiles"];

    // Build helper functions for any Firestore DB instance
    const buildFns = (db) => ({
      ...fs_db(db),
      ...fs_dbu(db),
      isProdDb: useProdDb
    });

    // Choose which DB to route to
    const route = (collectionName) => {
      const db = altCollections.includes(collectionName) ? altDb : _currentDb;
      return buildFns(db);
    };

    // Build a sample function map for auto-wrapping
    // const sampleFns = buildFns(_currentDb);
    // const autoRouteWrapper = {};

    // _.keys(sampleFns).forEach((fnName) => {
    //   autoRouteWrapper[fnName] = (...args) => {
    //     let collectionName = "";

    //     if (_.isString(args[0])) {
    //       collectionName = args[0];
    //     } else if (_.isObject(args[0])) {
    //       const refPath = _.get(args[0], "refPath");
    //       if (_.isString(refPath)) collectionName = refPath.split("/")[0];
    //     }

    //     return route(collectionName)[fnName](...args);
    //   };
    // });

    // console.log('autoRouteWrapper', autoRouteWrapper) 

    return {
      // ...autoRouteWrapper,   // legacy support
      route,                 // explicit routing
      ...buildFns(_currentDb),   // direct access to main DB
      // alt: buildFns(altDb),  // direct access to alt DB
    };
  }, [fsdb, mainDb, altDb, useProdDb]);
};
